export const isNumeric = (number: any) => {
  return Number.isNaN(number) === false
}
